import React, { Component } from 'react';

import AdmHeader from './AdmHeader';
import EditPageContent from './EditPageContent';
import EditAppUploader from './EditAppUploader';
import TOOLS from '../../componentes/TOOLS';

import '../css/EditAppPage.css';


class EditAppPage extends Component {
    constructor() {
        super();
        //this.serveUrl = "https://appstore.escolhatecnologia.com.br/api/";
        this.serveUrl = "http://localhost/new-appstore/api";
        this.newApp = true;
        this.formTitle = "Novo Aplicativo";
        this.state = {
            serverResponse: false,
            app: {
                icon: "https://appstore.escolhatecnologia.com.br/api/images/novo-app.jpg",
                id: "",
                featured: true,
                status: true,
                Contents: []
            },
            message: ""
        };
    }

    getApps(appId) {
        fetch(`${TOOLS.serverURL}/getApp/?appId=${appId}`)
            .then(response => response.json())
            .then(json => {
                if(json.ok){
                    let app = json.app;
                    this.setState({ app, serverResponse: true });

                    /*this.state.id = app.id;
                    this.state.featured = app.featured;
                    this.state.status = app.status ? 1 : 0;*/
                }else{
                    alert(`App (${appId}) não encontrado!`);
                }
                
            });
    }

    checkToken(){
        return new Promise(
          (resolve, reject) => { 
            let token= window.localStorage.getItem("AUTH-X-TOKEN");
            resolve(token);
          }
        );
    }

    saveOnServer() {
        const app = this.state.app;
        const form = new FormData()
        form.append('icon', app.icon);
        form.append('id', app.id);
        form.append('featured', app.featured);
        form.append('status', app.status);
        form.append('Contents', JSON.stringify(app.Contents));
        
        this.checkToken().then(token => {            
            if(token){
                form.append('AUTH-X-TOKEN', token);

                fetch(`${TOOLS.serverURL}/saveapp/`, {
                    method: "POST",
                    body: form
                }).then(response => response.json())
                .then(json => {
                    if (json.ok) {
                        this.setState({ message: "Salvo com sucesso!" });
                    } else {
                        this.setState({ message: "Falha ao salvar!" });
                    }
                });

            }else{
                window.alert("Falha ao recuperar o token");
                return false;
            };
        });


        
            /*.then(response => response.json())
            .then(json => {
                if (json.ok) {
                    this.setState({ message: "Salvo com sucesso!" });
                } else {
                    this.setState({ message: "Falha ao salvar!" });
                }
            });*/
    }

    handleUploadIcon(icon) {
        this.setState({ app: { ...this.state.app, icon } });
    }

    handleChangeSubmit(e) {
        e.preventDefault();
        this.setState({ message: "Aguarde..." });
        this.saveOnServer();
    }

    handleChange(e) {
        let obj = {};
        obj[e.target.name] = e.target.value;
        this.setState({ app: { ...this.state.app, ...obj } });
    }

    componentWillMount() {
        if (this.props.match.params.appId) {
            this.getApps(this.props.match.params.appId)
        } else {
            this.setState({ serverResponse: true });
        }
    }

    render() {
        let formTitle = 'Novo Aplicativo';

        if (this.state.serverResponse) {

            return (
                <div>
                    <AdmHeader />

                    <div className="formContent" >
                        <div className="card-title">{formTitle}</div>

                        <div className="form-container">
                            <label htmlFor="id">Id:</label>
                            <input type="text" name="id" id="id" onChange={this.handleChange.bind(this)} value={this.state.app.id} />
                        </div>
                        <div className="form-container">
                            <label htmlFor="icon">Ícone (350x350)</label>
                            <img className="uploader150px" src={this.state.app.icon} alt="Ícone (350x350)" />
                            <EditAppUploader 
                                appId={this.state.app.id}
                                lang=""
                                typeUpload="icon"
                                cssTag="uploader150px"
                                callBackUploadSuccess={this.handleUploadIcon.bind(this)}
                            />
                        </div>
                        <div className="form-container">
                            <label htmlFor="featured">App Destaque</label>
                            <select type="featured" name="featured" id="featured" onChange={this.handleChange.bind(this)} value={this.state.app.featured}>
                                <option value="true">SIM</option>
                                <option value="false">NÃO</option>
                            </select>
                        </div>
                        <div className="form-container">
                            <label htmlFor="status">Ativo</label>
                            <select type="status" name="status" id="status" onChange={this.handleChange.bind(this)} value={this.state.app.status} >
                                <option value="0">NÃO</option>
                                <option value="1">SIM</option>
                            </select>
                        </div>
                        <div className="form-container">
                            <button type="button" className="btn btn-primary" onClick={this.handleChangeSubmit.bind(this)}>Save</button>
                            <button type="button" className="btn btn-default">Cancel</button>
                        </div>
                        <div className="form-container">{this.state.message}</div>
                    </div>
                    <EditPageContent appId={this.state.app.id} contents={this.state.app.Contents} />
                </div>
            );
        } else {
            return (
                <div>
                    <AdmHeader />
                    <form className="formContent">
                        Carregando...
                </form>
                </div>
            );
        }

    }
}

export default EditAppPage;



// WEBPACK FOOTER //
// ./src/adm/componentes/EditAppPage.js